enum DocumentContentChangeType {
  Full = "full",
  Patch = "patch",
}
export default DocumentContentChangeType;
